// This file contains all the api paths used in the application

// BASE URL
export const baseURL = process.env.REACT_APP_BASE_URL;
// export const baseURL = 'http://localhost:8083/api';
// GET URL
export const getUserURL = `${baseURL}/user/by-ext-id/`;
export const tcsCorporateCreateUserGroupUrl = `${baseURL}/user-group`;
export const getTcsCorporateUserGroupUrl = `${baseURL}/user-group/list`;
export const getUserDetailUrl = `${baseURL}/user`;
export const getIndustryList = `${baseURL}/enum/Industry`;
export const getCompanyNameList = `${baseURL}/enum/CompanySize`;
export const getDepartmentNameList = `${baseURL}/enum/DepartmentSize`;
export const getCorporateSpendList = `${baseURL}/enum/CorporateSpend`;
export const getHowYouHereAboutUs = `${baseURL}/enum/HowYouHearAbout`;
export const getCountryList = `${baseURL}/country`;
export const getJurisdictionList = `${baseURL}/enum/Jurisdiction`;
export const getLanguageList = `${baseURL}/language`;
export const getTimeZonesList = `${baseURL}/enum/timeZones`;
export const getKeyAreasOfFocusList = `${baseURL}/enum/KeyAreasOfFocus`;
export const getRestructuringList = `${baseURL}/enum/RoleInRestructuringAndInsolvency`;
export const getCurrencyList = `${baseURL}/currency`;
export const getCorporateList = `${baseURL}/corporate`;
export const getCorporatePreview = `${baseURL}/corporate/preview`;
export const getLegalServicePreview = `${baseURL}/auth/ls/get-details`;
export const getLsSignUpDetails = `${baseURL}/auth/ls/get-details`;
export const getLegalServiceSelectList = `${baseURL}/enum/LegalServiceStatus`;
export const getTcsCorpUserGroupDetailUrl = `${baseURL}/user-group/get_detail`;
export const getTcsCorpUserListUrl = `${baseURL}/user/list`;
export const getTcsCorporateAddMemberDropUserGroupUrl = `${baseURL}/user/user-group`;
export const getRfpApproverList = `${baseURL}/rfp/list_by_approver`;
export const getTApproverListUrl = `${baseURL}/user/approver_list`;
export const getProposalTemplateBank = `${baseURL}/proposal-template-bank`;
export const getProposalTemplateBankDetail = `${baseURL}/proposal-template-bank`;
export const getProposalSideScreenUrl = `${baseURL}/rfp/by_rfp_id`;
export const getProposalCVUrl = `${baseURL}/proposal/view_cvs`;
export const getPastProposalsList = `${baseURL}/proposal/past_proposal`;

//PUT URL
export const putTcsCorpUserGroupUpdateStatusUrl = `${baseURL}/user-group/change-status`;
export const putTcsCorpAddOrRemoveAdminUrl = `${baseURL}/user-group/add-or-remove-admin`;
export const putSelectedBiddersUrl = `${baseURL}/proposal/update_proposal_score_card`;

export const getFile = `${baseURL}/auth/ls/get-file`;
export const getProposalList = `${baseURL}/proposal`;
export const getProposalDetailList = `${baseURL}/rfp`;
export const getAllProposalDetails = `${baseURL}/proposal/get_detail`;
export const getProposalStatus = `${baseURL}/enum/ProposalStatus`;

// POST URL
export const PostTcsCuSignup = `${baseURL}/auth/cu-signup`;
export const PostVendorSignup = `${baseURL}/auth/ls/signup`;
export const PostVendorSignUp = `${baseURL}/auth/ls/signup`;
export const PostVendorNonAccreditedSignUp = `${baseURL}/auth/ls/signup-non-accredited`;
export const PostVendorInviteAccessCheck = `${baseURL}/auth/ls/check-signup-invite`;
export const PostVendorUpload = `${baseURL}/auth/ls/upload-file`;
export const postUploadLogo = `${baseURL}/auth/ls/upload-logo`;
export const publicFileUpload = `${baseURL}/auth/public-file-upload`;
export const PostAdminInvite = `${baseURL}/legal-service/send-invite`;
export const PostTcsCorpUserUrl = `${baseURL}/user`;
export const PostNewTemplateUrl = `${baseURL}/rfp-template-bank`;
export const postTcsCorporate = `${baseURL}/corporate`;
export const postTcsVendor = `${baseURL}/vendor`;
export const inviteUser = `${baseURL}/auth/vendor-signup`;
export const postContactDetail = `${baseURL}/contact-us`;
//RFP POST URL

export const createSessionUrl = `${baseURL}/session`;

//RFP GET URL

export const getRFPStatusUrl = `${baseURL}/enum/code-by-type/RFPStatus`;
export const getBidders = `${baseURL}/legal-service/bidders`;
export const getRfpList = `${baseURL}/rfp/list`;
export const getRfpListAdmin = `${baseURL}/rfp/admin-rfp`;
export const getProposalStatusUrl = `${baseURL}/rfp`;
export const getURLForEnum = `${baseURL}/enum/`;
export const getRfpById = `${baseURL}/rfp/get_detail`;
export const getRfpPreviewById = `${baseURL}/rfp/preview_detail`;
export const analyticsURL = `${baseURL}/analytics`
export const serviceReviewURL = `${baseURL}/service-review`

// FILE Delete
export const postFileUploadURL = `${baseURL}/shared/upload-file`;
export const postCloneFileUploadURL = `${baseURL}/shared/clone-file`;
export const deleteFileUploadUrl = `${baseURL}/shared/delete-file`;
export const getFileUrl = `${baseURL}/shared/get-file`;
export const deleteFileUrl = `${baseURL}/shared/delete-file`;
export const deleteFilesUrl = `${baseURL}/shared/delete-files`;
export const getTcsCorporatePreferredPanelFileList = `${baseURL}/favorite-bidders-files`;

//RFP PUT URL

export const putProposalDetails = `${baseURL}/proposal`;
export const tcsCorporateUpdateUserGroupUrl = `${baseURL}/user-group`;

export const deleteSessionUrl = `${baseURL}/session`;
export const deleteAllSessionUrl = `${baseURL}/session/delete-all-session`;
export const deleteTcsCorpUserGroupUrl = `${baseURL}/user-group`;
export const deleteTcsCorpUserGroupMemberUrl = `${baseURL}/user-group/delete-member`;

//TEMPLATE BANK GET URL

export const templateBankUrl = `${baseURL}/rfp-template-bank`;

// GET VENDOR Template Bank

export const getVendorTemplateUrl = `${baseURL}/proposal-template-bank`;

// GET VENDOR MASTER TEMPLATE BANK
export const getVendorMasterTemplateUrl = `${baseURL}/master-proposal-template-bank`;
export const putVendorMasterTemplateUrl = `${baseURL}/master-proposal-template-bank`;
export const postVendorMasterTemplateUrl = `${baseURL}/master-proposal-template-bank`;

// PREFFERED PANEL GET URL
export const getPrefferedList = `${baseURL}/favorite-bidders`;
// export const removePreferredList = `${baseURL}`
// User Role Get API
export const getUserRoleList = `${baseURL}/user-role`;

// Bidders List
export const getBidderListURL = `${baseURL}/vendor/bidders`;

export const ConfigURL = `${baseURL}/Config`;
